export default __webpack_public_path__ + "static/media/phone2.a66436c5.svg";